import { Component, ViewEncapsulation } from '@angular/core';

import { AvatarBaseDirective } from './avatar-base';

@Component({
    selector: 'st-avatar[small]',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            *ngIf="shouldShowImage"
            width="20"
            height="20"
            [ngSrc]="imageUrl"
            (error)="onImageError()"
            (load)="imgLoaded()" />
        <div
            *ngIf="!shouldShowImage"
            class="st-avatar__initials">
            {{ initials }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarSmallComponent extends AvatarBaseDirective {}

@Component({
    selector: 'st-avatar[horizontal-small]:not([small])',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            width="24"
            height="24"
            [ngSrc]="imageUrl" />
        <div
            class="st-avatar__name"
            [matTooltip]="userName">
            {{ userName }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarSmallHorizontalNameComponent extends AvatarBaseDirective {}

@Component({
    selector: 'st-avatar[vertical-small]:not([small])',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            width="24"
            height="24"
            [ngSrc]="imageUrl" />
        <div
            class="st-avatar__name"
            [matTooltip]="userName">
            {{ userName }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarSmallVerticalNameComponent extends AvatarBaseDirective {}
